import { useId } from "react";
import { createPortal } from "react-dom";
import { Clock, RefreshCw } from "lucide-react";
import { Button } from "../../../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../ui/select";

interface EndpointTimeRangeControlsProps {
  container?: HTMLElement;
  value: string;
  onValueChange: (value: string) => void;
  onRefresh: () => void;
  refreshDisabled?: boolean;
}

export default function EndpointTimeRangeControls({
  container,
  value,
  onValueChange,
  onRefresh,
  refreshDisabled = false,
}: EndpointTimeRangeControlsProps) {
  const timeRangeId = useId();

  const controls = (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1.5">
        <label htmlFor={timeRangeId} className="flex items-center gap-1.5 px-1 text-[11px] font-medium uppercase tracking-wider text-muted-foreground/70">
          <Clock className="w-3.5 h-3.5" />
          Time Range
        </label>
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger id={timeRangeId} className="h-auto min-h-10 w-40 rounded-xl border-border/50 bg-card px-4 py-2.5 text-sm font-medium shadow-sm hover:border-sky-500/30 transition-colors">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="rounded-xl border-border/50 bg-popover/95 backdrop-blur-xl shadow-xl shadow-sky-500/10">
            <SelectItem value="24Hrs">Last 24 Hours</SelectItem>
            <SelectItem value="lw">Last 7 Days</SelectItem>
            <SelectItem value="lm">Last 30 Days</SelectItem>
            <SelectItem value="l3m">Last 90 Days</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="endpoint-time-refresh gap-2 rounded-xl border-border/50 bg-card px-4 py-2.5 text-sm font-medium shadow-sm hover:border-sky-500/30 transition-colors"
        onClick={onRefresh}
        disabled={refreshDisabled}
      >
        <RefreshCw className="w-4 h-4" />
        Refresh
      </Button>
    </div>
  );

  return container ? createPortal(controls, container) : controls;
}
